
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProcessusPage = lazy(() => import('../pages/processus/page'));
const OffrePage = lazy(() => import('../pages/offre/page'));
const AccelerateurPage = lazy(() => import('../pages/accelerateur/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const AProposPage = lazy(() => import('../pages/a-propos/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const MerciPage = lazy(() => import('../pages/merci/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/processus',
    element: <ProcessusPage />
  },
  {
    path: '/offre',
    element: <OffrePage />
  },
  {
    path: '/accelerateur',
    element: <AccelerateurPage />
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />
  },
  {
    path: '/a-propos',
    element: <AProposPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />
  },
  {
    path: '/merci',
    element: <MerciPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
